import React from 'react';
import {connect} from 'react-redux';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import ReactTable from "react-table";
import { TabsContainer, TabsPanel } from '../tabs/TabsContainer';
import XmlDataViewer from '../documentViewers/xml/XmlDataViewer';
import { TransmissionStatusResultEnum} from '../../utils/enums';
import FormattedDate from '../fields/dates/FormattedDate';
import NoData from '../page/NoData';
import Pagination from '../page/Pagination'
import { withFullStoryExclude } from '../../utils/fullStoryHelper';

const log = new Logger('TRANSACTION_DETAILS', LOG_LEVELS.DEBUG);
const transmissionStatusErrorValues = [
  TransmissionStatusResultEnum.ERROR,
  TransmissionStatusResultEnum.ABORTED,
  TransmissionStatusResultEnum.WARN
];

function isTransmissionError(status) {
  let transmissionStatus = (status && status+''.toUpperCase()) || '';
  return transmissionStatusErrorValues.includes(transmissionStatus);
}
 
export class TransactionDetails extends React.Component {

  render() {
    const columns = [{
      expander: true,
      Header: () => <span>Edit</span>,
      width: 65,
      Expander: ({ isExpanded, ...rest }) =>
          <s-icon name="chevron-down"></s-icon>,
      style: {
        cursor: "pointer",
        padding: "0",
        textAlign: "center",
        userSelect: "none"
      }
    }, {
        Header: props => <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_SupplierTaxNumber')}</span>,
        accessor: 'SupplierTaxNumber',
        filterable: true
      }, {
        Header: props => <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_SupplierName')}</span>,
        accessor: 'Supplier',
        filterable: true
      }, 
      {
        Header: props => <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_InvoiceNumber')}</span>,
        accessor: 'InvoiceNumber',
        filterable: true
      },
      {
        Header: props => <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_InvoiceDate')}</span>,
        accessor: 'InvoiceDate',
        filterable: true,
        Cell: props => <FormattedDate value={props.value}/>
      },
      {
        Header: props => <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_InvoiceAppearance')}</span>,
        accessor: 'InvoiceAppearance',
        filterable: true
      },
      {
        Header: props => <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_CustomerName')}</span>,
        accessor: 'CustomerName',
        filterable: true
      },
      {
        Header: props => <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_Operation')}</span>,
        accessor: 'Operation',
        filterable: true
      }
      , {
        Header: props => <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_Result')}</span>,
        accessor: 'Result',
        filterable: true
      }, {
        Header: props => <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_Error')}</span>,
        accessor: 'ErrorCode',
        filterable: true
      }, 
      {
        Header: props => <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_Message')}</span>,
        accessor: 'Message',
        filterable: true
      }, 
      {
        Header: props => <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_TransactionID')}</span>,
        accessor: 'TransactionId',
        filterable: true
      }, {
        Header: props => <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_GUID')}</span>,
        accessor: 'GUID',
        filterable: true
      }
    ]
    log.debug('render(): ', this.props);

    //const jsonViewerValues = this.props.formData && this.props.formData.structured;

    const getTrProps = (state, rowInfo, instance) => {
        if (rowInfo) {
          return {
            style: {
                background: isTransmissionError(rowInfo.row.Result) ? '#ffd9d9' : '',
                color: isTransmissionError(rowInfo.row.Result) ? '#000' : ''
            }
          }
        }
        return {};
      }

      const NoDataComponent = props => (
        <NoData
          noDataText="transmissionStatus_NoData"
          {...props}
        />
      )

      const transactionDetailsXMLReceived = <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_XMLReceived')}</span>;
      const transactionDetailsXMLSentHUB64 = <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_XMLSentHUB64')}</span>;
      const transactionDetailsXMLSentHUDecoded = <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_XMLSentHUDecoded')}</span>;
      const transactionDetailsXMLResponse = <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_XMLResponse')}</span>;

      return (
        <ReactTable
          defaultPageSize={this.props.defaultPageSize || 500}
          minRows={0}
          maxRows={0}
          manual
          getTrProps={getTrProps}
          data={this.props.data}
          columns={columns}            
          loading={this.props.loading} // Display the loading overlay when we need it
          onFetchData={this.props.onFetchData} // Request new data when things change
          pages={this.props.pages}
          pageSizeOptions={this.props.pageSizeOptions || [500, 1000, 2000, 'All']}            
          showPageJump={false}
          SubComponent={row => {
            //let encodedXMLSent = encodeDecode.base64Encode((row.original && row.original.XMLSent) || '');
          return (
            <div className={withFullStoryExclude('reactTable-expand-container p10')}>
              <p>{LANGUAGES_CONTROLLER.format(this.props.languages, 'transactionDetails_SelectXMLTitle')}</p>
              <TabsContainer>
                  <TabsPanel key={row.index} label={transactionDetailsXMLReceived}>
                    <XmlDataViewer id={row.index+'dataSupplied'}
                      xml={(row.original && row.original.DataSupplied) || ''}
                      filename="dataSupplied.xml"
                      prettify={true}
                    />
                  </TabsPanel>
                  <TabsPanel key={row.index} label={transactionDetailsXMLSentHUB64}>
                    <XmlDataViewer id={row.index+'dataSentEncoded'}
                      xml={ (row.original && row.original.DataSentEncoded) || ''}
                      filename="dataSentEncoded.xml"
                      prettify={false}
                    />
                  </TabsPanel>
                  <TabsPanel key={row.index} label={transactionDetailsXMLSentHUDecoded}>
                    <XmlDataViewer id={row.index+'dataSentDecoded'}
                      xml={(row.original && row.original.DataSentDecoded) || ''}
                      filename="dataSent_decoded.xml"
                      prettify={true}
                    />
                  </TabsPanel>
                  <TabsPanel label={transactionDetailsXMLResponse}> 
                    <XmlDataViewer id={row.index+'submissionResponse'}
                      xml={(row.original && row.original.SubmissionResponse) || ''}
                      filename="submissionResponse.xml"
                      prettify={true}
                    />
                  </TabsPanel>
              </TabsContainer>
            </div>
            );
          }}
          NoDataComponent={NoDataComponent}
          className={this.props.data.length === 0 ? 'mb20 hide-header' : 'mb20'}
          PaginationComponent={Pagination}
          showPagination={this.props.data.length === 0 ? false : true}
        />
    )
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);  
  return {
    languages: state.languages
  };
}


export default connect(mapStateToProps)(TransactionDetails);
